import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from 'src/app/core/dtos/cliente';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { PaymentService } from 'src/app/services/pago/payment.service';

@Component({
  selector: 'app-crear-pago',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './crear-pago.component.html',
  styleUrl: './crear-pago.component.css',
  standalone: true
})
export class CrearPagoComponent implements OnInit {

  form!: FormGroup;
  clientes: Cliente[] = [];
  loading = false;
  error = '';
  success = '';
  usuarioId: number = 0; 
  nombreCliente: string = '';
  constructor(
    private fb: FormBuilder,
    private clienteService: ClienteService,
    private paymentService: PaymentService,
    private router: Router,
    private route: ActivatedRoute,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
  // Verificar sesión
  const usuarioId = this.currentUserService.getUsuarioId();
  if (usuarioId) {
    this.usuarioId += usuarioId;
  } else {
    this.error = 'Primero debes iniciar sesión.';
    this.loading = false;
    return;
  }

  // Crear el form vacío por defecto
  this.form = this.fb.group({
    clienteId: ['', Validators.required],
    monto: ['', [Validators.required, Validators.min(1)]]
  });

  // Suscribirse SIEMPRE a los params
  this.route.queryParams.subscribe(params => {
    const clienteId = params['clienteId'];
    const montoSugerido = params['montoSugerido'];
    const nombreCliente = params['nombreCliente'];

    if (clienteId) {
      this.form.get('clienteId')?.setValue(clienteId);
    }
    if (montoSugerido) {
      this.form.get('monto')?.setValue(montoSugerido);
    }
    if (nombreCliente) {
      this.nombreCliente = nombreCliente;
    }
  });

  this.loadClientes();
}


  loadClientes() {
    this.clienteService.obtenerClientesPorUsuario(this.usuarioId).subscribe({
      next: (res) => this.clientes = res,
      error: () => this.error = 'Error al cargar clientes.'
    });
  }

  submit() {
    if (this.form.invalid) return;
    this.loading = true;
    this.error = '';
    this.success = '';

    const { clienteId, monto } = this.form.value;

    this.paymentService.createPayment(this.usuarioId,{ clienteId: +clienteId, monto: +monto }).subscribe({
      next: () => {
        this.success = 'Pago registrado correctamente.';
        this.loading = false;
        setTimeout(() => this.router.navigate(['/cliente']), 1500);
      },
      error: () => {
        this.error = 'Error al registrar el pago.';
        this.loading = false;
      }
    });
  }

  volverAtras(){
    this.router.navigate(['/cliente/libreta', this.form.get('clienteId')?.value]);
  }
}
